const AirArabiaShoppingReq = (req) => {
  const createSearchOnd = (origin, destination, date) => ({
    origin: {
      code: origin,
      locationType: "AIRPORT",
    },
    destination: {
      code: destination,
      locationType: "AIRPORT",
    },
    searchStartDate: date,
    searchEndDate: date,
    preferredDate: date,
    bookingType: "NORMAL",
    ondRef: `${origin}/${destination}`,
    interlineQuoteDetails: null,
  });

  const searchOnds = req.returnDate
    ? [
        createSearchOnd(req.origin, req.destination, req.departureDate),
        createSearchOnd(req.destination, req.origin, req.returnDate),
      ]
    : [createSearchOnd(req.origin, req.destination, req.departureDate)];

  const createPaxCount = (count, paxType) => ({
    count: count,
    paxType: paxType,
  });

  const paxCounts = [
    createPaxCount(req.adults, "ADT"),
    createPaxCount(req.chd, "CHD"),
    createPaxCount(req.inf, "INF"),
  ];

  return {
    searchOnds: searchOnds,
    paxCounts: paxCounts,
    isReturn: !!req.returnDate,
    currencyCode: "ETB",
  };
};

export { AirArabiaShoppingReq };
